import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Container from 'reactstrap/lib/Container';
import { heroDesktop, heroMobile } from 'client/images/inline-svgs/ads/home-hero-background';
import { EDMUNDS_LOGO_NO_TEXT } from 'client/images/inline-svgs/edmunds-logo';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';

import './brand-hero.scss';

export function BrandHero({
  children = null,
  contentClassName = null,
  breadcrumbs = null,
  breadcrumbsData = null,
  hasLogo = false,
  isMobile = false,
}) {
  return (
    <div className="brand-hero pos-r overflow-hidden">
      {isMobile && heroMobile({ className: null })}
      {!isMobile && heroDesktop({ className: null })}
      {!!(breadcrumbs || breadcrumbsData) && (
        <Container className="px-md-0">
          {breadcrumbs || <Breadcrumbs data={breadcrumbsData} className="ps-0 mb-0 text-white" />}
        </Container>
      )}
      <Container className={classnames('brand-hero-content pos-r', contentClassName)}>{children}</Container>
      {hasLogo && <EDMUNDS_LOGO_NO_TEXT fill="#FFFFFF" opacity={0.26} classes="edm-logo pos-a center-y right-0" />}
    </div>
  );
}

BrandHero.propTypes = {
  children: PropTypes.node,
  contentClassName: PropTypes.string,
  breadcrumbs: PropTypes.node,
  breadcrumbsData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
    })
  ),
  hasLogo: PropTypes.bool,
  isMobile: PropTypes.bool,
};
